<template>
  <div>
    <!--nav-bar></nav-bar-->
    <div class="login_tit">
       <img src="../../assets/image/xf_vue_index.jpg" hight="100px" width="100px" alt="center">
    </div>
    <section style="padding: 30px 30px; display: flex; flex-flow: column nowrap;">
      <div style="font-size: 20px; font-weight: bold;">用户注册</div>
	  <div>请务必确认注册时使用的姓名、手机号、身份证号正确无误，一经提交无法修改！</div>
      <div>
        <van-cell-group>
			<van-field
					v-model="name"
					clearable
					placeholder="请输入您的姓名"
					style="background-color: WhiteSmoke"
					ref="name"
			>
			</van-field>
          <van-field
                  v-model="idcard"
                  clearable
                  placeholder="请输入标准的身份证号"
                  style="background-color: WhiteSmoke"
                  ref="idcard"
          >
          </van-field>
          <van-field
                  v-model="pwd"
                  center
                  clearable
                  placeholder="包含大小字母、数字、特殊字符至少3种长度8位以上"
                  style="background-color: WhiteSmoke"
                  ref="pwd"
                  type="password"
          >
          </van-field>
		  <!-- <div style="font-size: 10px; color: red;"> *密码需包含大小字母、数字、特殊字符至少3种且长度8位以上</div> -->
          <van-field
                  v-model="checkpwd"
                  center
                  clearable
                  placeholder="请再次输入密码"
                  style="background-color: WhiteSmoke"
                  ref="checkpwd"
                  type="password"
          >
          </van-field>
		  <van-field
				v-model="tel"
				clearable
				placeholder="请输入手机号"
				style="background-color: WhiteSmoke"
				v-validate="'required|mobile'"
				ref="tel"
				@blur="blur"
		>
		</van-field>
		  <van-field
			  v-model="sms"
			  center
			  clearable
			  placeholder="请输入验证码"
			  style="background-color: WhiteSmoke"
			  v-validate="'required'"
			  ref="code"
		  >
		  <van-button slot="button" size="small" type="default" :disabled="btdisabled" @click="sendCode">{{ text }}</van-button>
		  </van-field>
        </van-cell-group>
        <span style="color: red" v-show="errMsg">{{ errMsg }}</span>
		<!-- <div style="font-size: 10px; color: red;"> *请务必确认注册时使用的姓名、手机号、身份证号正确无误，一经提交无法修改！</div> -->
      </div>

      <div style="background-color: DarkGray">
        <van-button :type="type" block :disabled="loginDisabled" @click="login">提交</van-button>
      </div>
      <!-- <div>
        忘记了？&nbsp;<a @click="toRetrievePwd">找回密码</a>
      </div> -->
    </section>
  </div>
</template>

<script>
  import NavBar from "@/components/NavBar";
  import {isPhone,IsCard,isPwd} from "@/utils/commons";
  import {auth_data}  from "@/utils/auth";
  import {register,sendLoginCode} from "@/api";

  export default {
    name: "Register",
    components: {NavBar},
    mounted(){
      // 输入框聚焦
      if(!this.name){
        this.$refs.name.focus();
      }else {
        this.$refs.idcard.focus();
      }
    },
    watch:{
      // 监听手机号和密码输入框，修改登录按钮状态和类型
      pwd(newVal){
        if(IsCard(this.idcard) && newVal.length > 7){
		  this.errMsg  = ''
          this.loginDisabled = false;
          this.type = 'danger'
        } else {
          this.loginDisabled = 'disabled';
          this.type = 'default'
        }
      },
      idcard(newVal, oldVal){
         if (newVal.length > 18) {
           this.idcard = oldVal;
           return
         }
        if(IsCard(this.idcard) && this.pwd.length >= 8){
          this.loginDisabled = false;
          this.type = 'danger'
        } else {
          this.loginDisabled = 'disabled';
          this.type = 'default'
        }
      }
    },
    data(){
      return {
        // 登录按钮类型
        type: 'default',
		//姓名
	    name : '仁青',
		//身份证
		idcard: '',
        // 手机号
        tel: '',
        // 密码
        pwd: '',
        //确认密码
        checkpwd: '',
		//验证码
		sms:'',
        // 错误提示信息
		text: '发送验证码',
        errMsg: '',
        // 登录按钮是否禁用
        loginDisabled: 'disabled',
		btdisabled:'disabled',
      }
    },
    methods: {
      blur(){
        // 修改store中phone
        if(isPhone(this.tel)){
          this.$store.commit('updatePhone', this.tel)
		  this.btdisabled = false;
        }else{
		  this.btdisabled = 'disabled';
		}
      },
      // 登录
      login(){
		  let that=this;
		  this.errMsg = '';
		  //验证码合法性
		  var key = auth_data(this.sms);
		  if(key !== this.$store.state.code){
		    that.errMsg = '验证码错误'
		    that.$refs.code.focus();
		    return
		  }
		  //验证密码
		if(!isPwd(this.pwd)){
			this.errMsg = '密码需包含大小字母、数字、特殊字符至少3种且长度8位以上';
			that.$refs.pwd.focus();
			return
		}
        if(this.pwd !==  this.checkpwd){
          this.errMsg = '两次输入密码不一致!';
		  that.$refs.pwd.focus();
          return
        }
		//调接口
        let params = {
          idcard: this.idcard,
          password: this.pwd,
		  phone: this.tel,
		  name: this.name,
        };
        register(params)
            .then(res => {
              if(res.code !== 200){
                this.errMsg = res.msg;
                // 密码输入错误时重新聚焦输入框
                this.$refs.pwd.focus();
              } else {
                this.$store.commit('login', res.data);
				this.$store.commit('updateIdcard', this.idcard);
				this.$store.commit('updateName', this.name);
                this.$router.push('/loginByPwd');
              }
            })
      },
	  // 发送验证码
	    sendCode(){
	      let params = {
	        phone: this.tel
	      };
	      sendLoginCode(params).then(data => {
	        if (data.code === 200) {
	          this.disabled = 'disabled';
	  		this.$store.commit('updateCode', data.data);
	          this.timer()
	        }
	      });
	    },
	    // 60s计时器
	    timer(){
	      let i = 60;
	      this.text = i;
	      let timerId = setInterval(() => {
	        if(i === 0){
	          clearInterval(timerId);
	          this.text = "重新发送";
	          this.disabled = false;
	          return
	        }
	        this.text = --i;
	      }, 1000);
	    }
    }
  }
</script>

<style scoped>
.login_tit {
  display: flex;
  justify-content: center;
  align-items: center;
}
.login_tit img{
  width : 100%;
}
  section div {
    margin-bottom: 16px;
  }
</style>
